export function formatDate(date) {
    if (!date || !(date instanceof Date)) {
        return date;
    }
    // Get the UTC date components
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getUTCMonth() returns months from 0-11
    const day = date.getDate();
    // Format the components into a YYYY-MM-DD string
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
